/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of a batch job or batch job member
 * @export
 */
export const WebApiModelsEnumerationTypesBatchStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;
export type WebApiModelsEnumerationTypesBatchStatus = typeof WebApiModelsEnumerationTypesBatchStatus[keyof typeof WebApiModelsEnumerationTypesBatchStatus];


export function WebApiModelsEnumerationTypesBatchStatusFromJSON(json: any): WebApiModelsEnumerationTypesBatchStatus {
    return WebApiModelsEnumerationTypesBatchStatusFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesBatchStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesBatchStatus {
    return json as WebApiModelsEnumerationTypesBatchStatus;
}

export function WebApiModelsEnumerationTypesBatchStatusToJSON(value?: WebApiModelsEnumerationTypesBatchStatus | null): any {
    return value as any;
}

